<template>

  <b-card no-body class="oc-list-card">

    <b-card-body class="p-0">

      <b-alert v-if="loadError" variant="warning" show class="m-1 mb-0 py-75">

        <feather-icon icon="AlertTriangleIcon" size="16" class="mr-50" />

        {{ loadError }}

      </b-alert>



      <div class="oc-table-wrap">

        <b-table

          :items="items"

          :fields="tableFields"

          hover

          show-empty

          :busy="loading"

          class="oc-config-table mb-0 h6"

          thead-class="oc-config-table__head"

          tbody-class="oc-config-table__body"

        >

          <template #table-busy>

            <div class="text-center py-3">

              <b-spinner variant="primary" />

              <div class="mt-50 text-muted small">Loading templates…</div>

            </div>

          </template>



          <template #empty>

            <div class="oc-empty-state text-center py-4 px-2">

              <div class="oc-empty-icon mx-auto mb-1">

                <feather-icon icon="FileTextIcon" size="40" class="text-primary" />

              </div>

              <h5 class="mb-50 font-weight-bold">

                {{ hasListFilters ? 'No matching templates' : 'No offer templates yet' }}

              </h5>

              <p class="text-muted mb-1 mx-auto oc-empty-desc">

                <template v-if="hasListFilters">

                  Try a different search, or switch the Active / Inactive toggle.

                </template>

                <template v-else>

                  Create your first template to define offer letter content, salary tables, and branding for a site.

                </template>

              </p>

              <b-button

                v-if="canManage && !hasListFilters"

                variant="primary"

                class="oc-touch-btn"

                @click="$emit('create')"

              >

                <feather-icon icon="PlusIcon" size="16" class="mr-50" />

                Create First Template

              </b-button>

              <b-button

                v-else-if="hasListFilters"

                variant="outline-secondary"

                class="oc-touch-btn"

                @click="$emit('clear-filters')"

              >

                <feather-icon icon="XIcon" size="14" class="mr-50" />

                Clear filters

              </b-button>

            </div>

          </template>



          <template #cell(client)="data">

            <div class="d-flex align-items-center h6 mb-0">

              <feather-icon icon="BriefcaseIcon" size="16" class="text-muted mr-50 flex-shrink-0" />

              <span>{{ data.item.client || '—' }}</span>

            </div>

          </template>



          <template #cell(jobTitle)="data">

            <span class="oc-cell-job h6 mb-0">{{ data.item.jobTitle || '—' }}</span>

          </template>



          <template #cell(location)="data">

            <div v-if="data.item.location" class="d-flex align-items-center text-muted h6 mb-0">

              <feather-icon icon="MapPinIcon" size="14" class="mr-25 flex-shrink-0" />

              {{ data.item.location }}

            </div>

            <span v-else class="text-muted h6 mb-0">—</span>

          </template>



          <template #cell(is_active)="data">

            <b-badge

              :variant="data.item.is_active ? 'light-success' : 'light-secondary'"

              class="oc-status-badge h6 mb-0"

            >

              <feather-icon

                :icon="data.item.is_active ? 'CheckCircleIcon' : 'MinusCircleIcon'"

                size="14"

                class="mr-25"

              />

              {{ data.item.is_active ? 'Active' : 'Inactive' }}

            </b-badge>

          </template>



          <template #cell(actions)="data">

            <div
              class="oc-row-actions d-flex align-items-center justify-content-end"
              @click.stop
            >

              <b-dropdown

                variant="link"

                toggle-class="text-decoration-none p-0 oc-more-toggle"

                menu-class="oc-actions-dropdown-menu"

                no-caret

                right

                boundary="viewport"

                no-flip

                :popper-opts="{ positionFixed: true }"

              >

                <template #button-content>

                  <feather-icon icon="MoreVerticalIcon" size="17" class="text-muted" />

                </template>

                <b-dropdown-item @click.stop="$emit('edit', data.item)">

                  <feather-icon
                    :icon="canManage ? 'EditIcon' : 'EyeIcon'"
                    size="14"
                    class="mr-50 text-primary"
                  />

                  {{ canManage ? 'Edit' : 'View' }}

                </b-dropdown-item>

                <template v-if="canManage">

                  <b-dropdown-item @click.stop="$emit('replicate', data.item)">

                    <feather-icon icon="CopyIcon" size="14" class="mr-50 text-primary" />

                    Duplicate template

                  </b-dropdown-item>

                  <b-dropdown-item @click.stop="$emit('toggle-status', data.item)">

                    <feather-icon
                      :icon="data.item.is_active ? 'MinusCircleIcon' : 'CheckCircleIcon'"
                      size="14"
                      class="mr-50"
                      :class="data.item.is_active ? 'text-warning' : 'text-success'"
                    />

                    {{ data.item.is_active ? 'Set Inactive' : 'Set Active' }}

                  </b-dropdown-item>

                  <b-dropdown-divider />

                  <b-dropdown-item variant="danger" @click.stop="$emit('delete', data.item)">

                    <feather-icon icon="Trash2Icon" size="14" class="mr-50" />

                    Delete

                  </b-dropdown-item>

                </template>

              </b-dropdown>

            </div>

          </template>

        </b-table>

      </div>

    </b-card-body>

  </b-card>

</template>



<script>

import {

  BCard,

  BCardBody,

  BAlert,

  BTable,

  BBadge,

  BButton,

  BDropdown,

  BDropdownItem,

  BDropdownDivider,

  BSpinner,

} from 'bootstrap-vue'



export default {

  name: 'OfferConfigureListTable',

  components: {

    BCard,

    BCardBody,

    BAlert,

    BTable,

    BBadge,

    BButton,

    BDropdown,

    BDropdownItem,

    BDropdownDivider,

    BSpinner,

  },

  props: {

    items: { type: Array, default: () => [] },

    tableFields: { type: Array, required: true },

    loading: { type: Boolean, default: false },

    loadError: { type: String, default: '' },

    canManage: { type: Boolean, default: false },

    hasListFilters: { type: Boolean, default: false },

  },

}

</script>



<style scoped>

.oc-list-card {

  border: 1px solid #eef0f3;

  border-radius: 0.35rem;

  box-shadow: none !important;

  overflow: hidden;

  background: #fff;

}



.oc-table-wrap {

  max-height: calc(100vh - 16rem);

  overflow: auto;

  -webkit-overflow-scrolling: touch;

}



.oc-touch-btn {

  min-height: 2.375rem;

}



.oc-empty-icon {

  width: 4.5rem;

  height: 4.5rem;

  border-radius: 50%;

  background: rgba(0, 186, 176, 0.12);

  display: flex;

  align-items: center;

  justify-content: center;

}



.oc-empty-desc {

  max-width: 26rem;

  line-height: 1.5;

  font-size: 0.875rem;

}



.oc-config-table {

  border-collapse: separate;

  border-spacing: 0;

}



.oc-config-table >>> thead.oc-config-table__head th {

  position: sticky;

  top: 0;

  z-index: 3;

  font-weight: 700;

  text-transform: uppercase;

  letter-spacing: 0.05em;

  color: #6e6b7b;

  border-top: none;

  border-bottom: 1px solid #e5e7eb;

  background: #f3f4f6;

  background-clip: padding-box;

  padding: 0.65rem 0.85rem;

  white-space: nowrap;

  box-shadow: none;

}



.oc-config-table >>> tbody.oc-config-table__body td {

  vertical-align: middle;

  padding: 0.7rem 0.85rem;

  border-color: #f3f4f6;

}



.oc-config-table >>> tbody.oc-config-table__body tr {

  transition: background 0.15s ease;

  position: relative;

}



.oc-config-table >>> tbody.oc-config-table__body tr:hover {

  background: rgba(0, 186, 176, 0.04);

  z-index: 1;

}



.oc-config-table >>> tbody.oc-config-table__body tr:hover td:first-child {

  box-shadow: inset 3px 0 0 #00bab0;

}



.oc-cell-job {

  font-weight: 500;

}



.oc-status-badge {

  font-weight: 600;

  padding: 0.25rem 0.5rem;

  border: 0 !important;

  box-shadow: none !important;

  border-radius: 0.25rem;

}



.oc-more-toggle {

  width: 2rem;

  height: 2rem;

  display: inline-flex;

  align-items: center;

  justify-content: center;

  border-radius: 0.35rem;

  transition: background 0.15s;

}



.oc-more-toggle:hover {

  background: #f3f4f6;

}



.oc-row-actions {

  position: relative;

  z-index: 2;

}



.oc-actions-dropdown-menu {

  z-index: 1050 !important;

  background: #fff;

  border: 1px solid rgba(0, 0, 0, 0.08);

  box-shadow: 0 4px 24px rgba(34, 41, 47, 0.16);

  min-width: 11rem;

}



.oc-actions-dropdown-menu >>> .dropdown-item {

  display: flex;

  align-items: center;

}


</style>

